var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Slice',[_c('DirectoryListings',{attrs:{"clean":"","items":_vm.slice.items.map(a => a.item)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }